import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetOutdoorBarArticleCategoriesApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            category: z.object({
                documentId: z.string(),
                slug: z.string(),
            }).optional().nullable(),
        }),
    ),
});

type GetOutdoorBarArticleCategoriesActionResponse
    = ApiResponse<z.infer<typeof GetOutdoorBarArticleCategoriesApiResponseSchema>>
    | BaseError;

type GetOutdoorBarArticleCategoriesActionRequest = undefined

export const getOutdoorBarArticleCategories = createAsyncThunk<
    GetOutdoorBarArticleCategoriesActionResponse,
    GetOutdoorBarArticleCategoriesActionRequest
>(
    'OutdoorBarsPageActionsGetOutdoorBarArticleCategories',
    async () => apiInstance.get(
        '/outdoor-bar-article-categories',
        {},
        GetOutdoorBarArticleCategoriesApiResponseSchema,
    ),
);
